export const countEl = `<span class="mini-cart-toggle__count"></span>`;
